/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/24
 * @updateTime 2021/8/24
 * @decription 申请保全 =》担保信息模块
 */
// 模块预览组件
import ccPreviewModule from '@/components/common/preview-module/index.vue';
import {typeDbfs, typeSddy} from "@/filters";
export default {
    name: 'DBXX',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        ccPreviewModule
    },
    // 参数
    props: {},
    // 数据
    data() {
        return {
            // 数据
            data: [],
            // 担保价值
            dbzjz: 0,
            // 转换后的数据
            transformData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 获取基本数据
        this.getData();
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 请求数据
         * @param {Object} params 请求参数
         * */
        requestData(params) {
            return this.$axios.get('ssbq/api/dbxxs', params);
        },

        /**
         * 获取行数据
         * @param {String} name 名称
         * @param {String|Number} value 值
         * @returns {Object}
         * */
        getRowData(name, value) {
            return {
                name: name,
                value: value
            };
        },

        /**
         * 获取转化之后的数据
         * @returns {Array} 转化之后的信息项数组
         * */
        getTransformData(data) {
            const _transformItemData = [];
            _transformItemData.push(this.getRowData('担保方式', data.cDbfsName));
            _transformItemData.push(this.getRowData('担保物名称', data.dbwmcName));
            _transformItemData.push(this.getRowData('财产/担保信息', data.cDbsmName));
            _transformItemData.push(this.getRowData('财产价值（元', data.nDbjzName));
            return _transformItemData;
        },
        // 担保物名称
        dbwmcValue(item) {
            switch (item.cDbfs) {
                case "1":
                    return '保证金'
                case "2":
                    return item.cDbwmc
                case "3":
                    return typeSddy(item.cCclx)
                case "4":
                    return typeSddy(item.cCclx)
                case "5":
                    return '诉讼保全责任保险'
            }
        },
        // 担保说明
        dbxxValue(item) {
            if (item.cDbfs === '5') {
                return item.nSysbuy === 1 ? `${item.cBxgsmc} 保单号：${item.cBdh}` : `${item.cBxgsmc}`
            } else {
                return item.cDbsm || '--'
            }
        },

        /**
         * 获取数据
         * */
        getData() {
            // 请求保全基本信息数据
            this.requestData({
                // 保全id
                bqid: sessionStorage.getItem('bqid')
            }).then(res => {
                const _data = res.data;
                const _transformData = [];
                let num = 0;
                _data.forEach((item) => {
                    // 担保方式名称
                    item.cDbfsName = typeDbfs(item.cDbfs);
                    // 担保物名称
                    item.dbwmcName = this.dbwmcValue(item);
                    // 财产/担保信息
                    item.cDbsmName = this.dbxxValue(item);
                    // 财产价值（元）
                    item.nDbjzName = item.nDbjz === '' ? '--' : Number(item.nDbjz).toFixed(2);
                    num += Number(item.nDbjz) * 100;
                    // 转化之后的数据
                    _transformData.push(this.getTransformData(item));
                });
                // 财产总价值
                this.dbzjz = (num/100).toFixed(2);
                this.data = _data;
                // 转化之后的数据
                this.transformData = _transformData;
                // 加载完成
                this.$emit('loaded', this.basicData);
            });
        }
    }
};
